import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_FIRST_BOOKING_WELCOME_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemFirstBookingDiscountMaybe = ({ lineItems, intl }) => {
  const item = lineItems.find(
    i => i.code === LINE_ITEM_FIRST_BOOKING_WELCOME_DISCOUNT && !i.reversal
  );
  if (!item) {
    return null;
  }
  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.firstBookingWelcomeDiscount" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, item.lineTotal)}</span>
    </div>
  );
};

LineItemFirstBookingDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemFirstBookingDiscountMaybe;
